import { geoMasterAPI } from "./clients";

/**
 * Fetches all the available cities based on entity_id provided
 * @param {String} entity_id
 */
const getCities = entity_id => {
  return geoMasterAPI.get(`/geometry/city?entity_id=${entity_id}`);
};

const mapLatLongToCity = latlong => {
  // console.log({ latlong });
  return geoMasterAPI.post(`/geometry/city`, {
    lon: latlong[0],
    lat: latlong[1],
  });
};

export { getCities, mapLatLongToCity };
